export const ADD_ZONE_SUCCESS = "redux_store:zones.success.add";
export const DELETE_ZONE_SUCCESS = "redux_store:zones.success.delete";
export const UPDATE_ZONE_SUCCESS = "redux_store:zones.success.update";



// WEBPACK FOOTER //
// ./src/successes/zones.js